export default "__VITE_ASSET__cP1nK$Hh__"